export default __webpack_public_path__ + "static/media/tkit-1-sm.62367120.svg";